import { render, staticRenderFns } from "./introduce-series.vue?vue&type=template&id=2aa19c2d&scoped=true&"
import script from "./introduce-series.vue?vue&type=script&lang=ts&"
export * from "./introduce-series.vue?vue&type=script&lang=ts&"
import style0 from "./introduce-series.vue?vue&type=style&index=0&id=2aa19c2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa19c2d",
  null
  
)

export default component.exports